module.exports = "<button (click)=\"signout()\">Logout</button>"